import { render, staticRenderFns } from "./NewsListContainer.vue?vue&type=template&id=6ee0ef85&scoped=true"
import script from "./NewsListContainer.vue?vue&type=script&lang=js"
export * from "./NewsListContainer.vue?vue&type=script&lang=js"
import style0 from "./NewsListContainer.vue?vue&type=style&index=0&id=6ee0ef85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee0ef85",
  null
  
)

export default component.exports